import { Box, Button, Grid } from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";

const AccountHeader = ({ navigate, isAdmin }) => {
  return (
    <Grid
      style={{ margin: 15 }}
      justifyContent="space-between"
      alignItems="center"
      display="flex"
      item
    >
      <CustomTypography style={{ fontWeight: "bold" }} variant="h6">
        ACCOUNT SETTINGS
      </CustomTypography>

      <Box sx={{ display: "flex" }}>
        <Button
          variant="outlined"
          sx={{
            textTransform: "none",
            mr: 3,
            fontFamily: "poppins",
            fontWeight: 500,
            fontSize: "12px",
          }}
          onClick={() => navigate(isAdmin ? "/admin-config" : "/client-config")}
        >
          Config
        </Button>

        {/* <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              mr: 3,
              fontFamily: "poppins",
              fontWeight: 500,
              fontSize: "12px",
            }}
            onClick={() => navigate("/assign-user")}
          >
            + Assign User
          </Button> */}
      </Box>
    </Grid>
  );
};

export default AccountHeader;
